<template>
	<section class="experience-pre-builder" v-if="isTokenChecked">
		<Grid>
			<Column v-if="!isAddonShop">
				<h2 class="mb-10">{{ $t('page.shop.experience_prebuilder.title') }}</h2>
				<span class="experience-pre-builder__festival"></span>

				<div
					class="experience-pre-builder__option"
					v-for="(item, index) in preregistrationOptions"
					:key="index"
				>
					<h4 class="experience-pre-builder__title">
						{{ $t(`page.shop.experience_prebuilder.form[${index}]`) }}
					</h4>

					<div
						class="experience-pre-builder__flex-wrapper"
						:class="{
							'experience-pre-builder__flex-wrapper--small': index >= 1
						}"
					>
						<Button
							class="experience-pre-builder__choice-button"
							v-for="(radio, count) in item.type"
							:key="radio.option + count"
							@click.native="
								!radio.hasOwnProperty('external_url')
									? onClickChoice(radio.option)
									: onClickExternal(radio.external_url)
							"
						>
							{{ radio.title }}
						</Button>
					</div>
				</div>
			</Column>
			<Column v-else>
				<div class="align-center">
					<h2 class="mb-10">{{ $t('page.shop.experience_prebuilder.title') }}</h2>
					<div
						class="experience-pre-builder__festival"
						v-html="$t('page.shop.experience_prebuilder.lead')"
					></div>
				</div>
				<div
					class="experience-pre-builder__option"
					v-for="(item, index) in preregistrationOptions"
					:key="index"
				>
					<h4 class="experience-pre-builder__title">
						{{ $t(`page.shop.experience_prebuilder.form[${index}]`) }}
					</h4>

					<div
						class="experience-pre-builder__flex-wrapper"
						:class="{
							'experience-pre-builder__flex-wrapper--small': index >= 1
						}"
					>
						<Button
							class="experience-pre-builder__choice-button"
							v-for="(radio, count) in item.type"
							:key="radio.option + count"
							@click.native="
								!radio.hasOwnProperty('external_url')
									? onClickChoice(radio.option)
									: onClickExternal(radio.external_url)
							"
						>
							{{ radio.title }}
						</Button>
					</div>
				</div>
			</Column>
		</Grid>
	</section>

	<section v-else class="experience-pre-builder__loader">
		<Spinner />
	</section>
</template>

<script>
import SelectField from '@/components/ui/SelectField';
import LargeRadio from '@/components/ui/LargeRadio';
import preserveUTMParams from '@/utils/preserveUTMParams';

export default {
	name: 'ExperiencePrebuilder',

	data() {
		return {
			choices: {
				selected: []
			},
			error: {
				ticket: true,
				transportation: true,
				adults: true
			},
			isTokenChecked: false
		};
	},

	components: {
		SelectField,
		LargeRadio
	},

	computed: {
		brand() {
			return this.$store.getters.getBrand;
		},
		preregistrationOptions() {
			// For legacy purposes. Shops in CTF might still have other options in de json but we only show the tickets/travel choice.
			let types = this.shopConfig.preregistrationOptions.filter(option => option.type[0].type === 'ticket');
			let tempTypes = [];
			if (Object.keys(this.previousOrderTravelItems).length) {
				if (types[0].type) {
					tempTypes = [{ type: types[0].type.filter(item => item.option !== 'travel') }];
				}
			} else {
				tempTypes = [{ type: types[0].type.filter(item => item.option !== 'traveladdon') }];
			}
			return tempTypes;
		},
		shopUpdateState() {
			return this.$store.getters['shopapi/getShopUpdateState'];
		},
		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		},
		paylogicToken() {
			return this.$store.getters['shopconfig/getPaylogictoken'];
		},
		ossConfig() {
			return this.$store.getters.getOssConfig;
		},
		upgradeOrderId() {
			return this.$store.getters.getUpgradeOrderId;
		},
		accessId() {
			return this.$store.getters.getAccessId;
		},
		isAddonShop() {
			return this.shopConfig.shopInit && this.shopConfig.shopInit.isAddOnShop;
			// return this.shopConfig.shopInit && true
		},
		previousOrderTravelItems() {
			const prevProducts = this.$store.getters['shopapi/getPurchasedProducts'];
			const prevOrders = prevProducts && prevProducts.data.data['original_orders'];
			const hasPrevTravelOrder = {};
			!!prevOrders &&
				prevOrders.forEach(order => {
					const orderReference = order.reference;
					order.purchases.forEach(purchase => {
						if (purchase.title.search('Travel:') != -1) {
							hasPrevTravelOrder[`${orderReference}`] = purchase;
						}
					});
				});
			return hasPrevTravelOrder;
		},
		getPaymentProvider() {
			return this.$store.getters['shopconfig/getPaymentProvider'];
		}
	},

	watch: {
		isLoginChecked(val) {
			if (val) {
				this.redirectLogic();
			}
		}
	},

	methods: {
		onClickChoice(choice) {
			const routeName = {
				packages: 'slug-packages',
				ticket: 'slug-tickets',
				travel: 'slug-travel',
				traveladdon: 'slug-traveladdon'
			}[choice];
			setTimeout(() => {
				this.$store.commit('setPrebuilderChoice', routeName);
			}, 500);

			this.$router.push({ name: routeName });
		},

		onClickExternal(url) {
			window && (window.location = url);
		},

		redirectLogic() {
			let urlQueryParams;
			let deeplinkParams;

			// Check if we have a deeplink (query param route is then in url)
			if (!this.$cookies.get('shop_deeplink') && this.$route.query.route) {
				const deeplink = {
					route: this.$route.query.route,
					slug: this.$route.query.slug || null,
					category: this.$route.query.category || null,
					raw: `${this.$route.fullPath.split('?')[1]}`
				};
				this.$cookies.remove(`shop_deeplink`);
				this.$cookies.set(`shop_deeplink`, JSON.stringify(deeplink), {
					path: '/',
					maxAge: 6 * 30 * 24 * 3600 // 6 months
				});
			}

			// If statement toegevoegd na thunderdome bug: shop bleef redirecten met een fake token,
			// zelfs als je binnenkomt vanuit de queue met een geldige paylogic token.
			if (!this.$route.query.token) {
				const token = Math.random().toString(36).substring(7);
				const orderId = this.upgradeOrderId || this.$route.query.idt_oss_order_id || null;
				const accessId = this.accessId || this.$route.query.access_id || null;
				const deeplink = this.$cookies.get('shop_deeplink');

				urlQueryParams = new URLSearchParams(window.location.search);

				if (deeplink) {
					urlQueryParams = new URLSearchParams({
						...deeplinkParams,
						...Object.fromEntries(urlQueryParams)
					});
				}

				if (urlQueryParams.has('token') === false && token !== null) urlQueryParams.set('token', token);

				if (urlQueryParams.has('idt_oss_order_id') === false && orderId !== null)
					urlQueryParams.set('idt_oss_order_id', orderId);

				if (urlQueryParams.has('access_id') === false && accessId !== null)
					urlQueryParams.set('access_id', accessId);

				if (window.location.hostname === 'localhost') {
					window.location.replace(
						preserveUTMParams(
							`http://localhost:8081/${this.$route.params.slug}?${urlQueryParams.toString()}`
						)
					);
				} else {
					if (
						this.shopConfig.shopInit.paymentQueueEnabled &&
						!this.paylogicToken &&
						!this.shopConfig.queueUrl
					) {
						console.log(
							'WARNING: shop payment queue is enabled but no queue url was found. Skipping queue...'
						);
					}

					if (
						this.shopConfig.shopInit.paymentQueueEnabled &&
						!this.paylogicToken &&
						this.shopConfig.queueUrl
					) {
						try {
							if (this.getPaymentProvider === 'adyen') {
								urlQueryParams.set('token', controller.getAccessTokens().idToken);
							}
						} catch {
							/*no need to catch */
						}

						if (this.shopConfig.queueUrl) urlQueryParams.delete('token');

						window.location.replace(
							preserveUTMParams(`${this.shopConfig.queueUrl}?${urlQueryParams.toString()}`)
						);
					} else {
						let shopBase = 'shop';

						switch (this.brand) {
							case 'zwartecross':
								shopBase = process.env.ENV === 'uat' ? 'uat-shop' : 'tickets';
								break;
							default:
								shopBase = process.env.ENV === 'uat' ? 'uat-shop' : 'shop';
								break;
						}

						window.location.replace(
							preserveUTMParams(
								`https://${shopBase}.${this.ossConfig.shopDomain}/${
									this.$route.params.slug
								}?${urlQueryParams.toString()}`
							)
						);
					}
				}
			} else {
				this.isTokenChecked = true;
			}
		}
	},

	mounted() {
		this.redirectLogic();
	}
};
</script>

<style lang="scss">
$component: 'experience-pre-builder';
.align-center {
	// text-align: center;
	margin: 0 auto;
}
.mb-10 {
	margin-bottom: 10px;
}

.#{$component} {
	&__festival {
		display: block;
		font-size: 14px;
		padding-bottom: 30px;
	}

	&__option {
		padding-bottom: 40px;
	}

	&__flex-wrapper {
		display: flex;
	}

	&__title {
		font-family: $font-bold;
		font-size: 14px;
		color: var(--detail-text-color);

		padding-bottom: 10px;

		text-transform: uppercase;
	}

	&__error {
		border: 1px solid $color-red;
	}

	&__loader {
		min-height: 50vh;
	}

	@include md-lg {
		&__choice-button {
			&:not(:last-of-type) {
				margin-right: 30px;
			}
		}
	}

	@include sm {
		position: relative;

		padding-top: 40px;

		&:before {
			content: '';
			display: block;

			position: absolute;

			width: calc(100% + 60px);
			height: 100%;
			background-color: var(--content-background);

			z-index: -1;

			left: -40px;
			top: 0px;
		}

		&__flex-wrapper {
			display: block;

			&--small {
				display: flex;
			}
		}

		&__choice-button {
			&:not(:last-of-type) {
				margin-bottom: 20px;
			}
		}
	}
}
</style>
